import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TThunkDispatch } from '../../types/redux';
import { IFiltersUpdatedEventDetail } from '../../types/desktopFilters';
import { setJsonQuery } from '../../actions/filters';
import { ISearchMeta } from '../../types/searchMeta';
import { useApplicationContext } from '../../utils/applicationContext';

const FILTERS_UPDATED_EVENT = 'filters:updated';
const ADVANCED_FILTERS_UPDATED_EVENT = 'advancedFilters:updated';

/**
 * Подписывается на событие из микрофронта на применение фильтров
 * @returns {object} searchMeta - метаданные поиска из события фильтров
 */
export const useFiltersUpdatedEvent = () => {
  const { microfrontendsAPI } = useApplicationContext();
  const dispatch = useDispatch<TThunkDispatch>();
  const [searchMeta, setSearchMeta] = useState<ISearchMeta>();
  const [advancedFiltersReceived, setAdvancedFiltersReceived] = useState(false);

  useEffect(() => {
    if (advancedFiltersReceived && searchMeta?.fullUrl) {
      window.location.href = searchMeta.fullUrl;

      setAdvancedFiltersReceived(false);
    }
  }, [advancedFiltersReceived, searchMeta]);

  useEffect(() => {
    const onFiltersUpdated = ({ detail }: CustomEvent<IFiltersUpdatedEventDetail>) => {
      dispatch(setJsonQuery(detail.jsonQuery));

      setSearchMeta(detail.searchMeta);

      if (microfrontendsAPI) {
        microfrontendsAPI.getSearchStringMicrofrontendAPI().setFilterJsonQuery(detail.jsonQuery);
      }
    };

    addEventListener(FILTERS_UPDATED_EVENT, onFiltersUpdated);

    return () => {
      removeEventListener(FILTERS_UPDATED_EVENT, onFiltersUpdated);
    };
  }, [dispatch]);

  useEffect(() => {
    const onAdvancedFiltersUpdated = () => {
      setAdvancedFiltersReceived(true);
    };

    addEventListener(ADVANCED_FILTERS_UPDATED_EVENT, onAdvancedFiltersUpdated);

    return () => {
      removeEventListener(ADVANCED_FILTERS_UPDATED_EVENT, onAdvancedFiltersUpdated);
    };
  }, [searchMeta]);

  return { searchMeta };
};
